module.exports = __webpack_public_path__ + "static/media/settings.cc632e92.svg";